export const formatNumber = (val)=>new Intl.NumberFormat().format(val);
